import React, { memo } from 'react'
import { CopyIcon } from 'uiComponents/buttons/copyIcon'

const ApfRow: React.FC<{
    label: string
    value?: string
    showCopy?: boolean
}> = memo(({ label, value, showCopy }) => (
    <div className="customer-info-row">
        <div className="customer-info-row-label" title={label}>
            {label}
        </div>
        <div className="customer-info-row-value" title={value}>
            {showCopy ? <div className="customer-info-row-value-text">{value || ''}</div> : value || ''}
            {showCopy && <CopyIcon text={value || ''} />}
        </div>
    </div>
))

ApfRow.displayName = 'ApfRow'

export default ApfRow
